import { Chip, Grid } from "@mui/material";
import React from "react";

const RecipeContainerOptionsGrid = () => {
  return (
    <Grid
      container
      justify="flex-end"
      direction="row"
      alignItems="center"
      justifyContent="center"
      className="sticky top-[190px] bg-[#e5e5e5] store-options-chips-tour-selector"
    >
      <Chip size="small" className="m-2" label="QC: Quarter Container" />
      <Chip size="small" className="m-2" label="HC: Half Container" />
      <Chip size="small" className="m-2" label="SC: Single Container" />
      <Chip size="small" className="m-2" label="DC: Double Container" />
    </Grid>
  );
};

export default RecipeContainerOptionsGrid;
